import React from 'react';



const HeaderSection = ({title}) => {
    return (
        <div className='w-ful flex text-sm font-semibold justify-start gap-2 mb-1 border-b-2 border-p-green'>
            <h1 className='mb-2 text-p-orange'>{title}</h1>
        </div>
    );
};

export default HeaderSection;